import { createFileRoute } from "@tanstack/react-router"

import ScreenLayout from "@/layouts/screen"

export const Route = createFileRoute("/_screen")({
  component: ScreenLayout
})
